import React from 'react';
import { useTranslate } from 'shared/helper/translate';
import { formatForLocale } from '../../helpers/date';
import RubriqAbstractCopyDownload from './RubriqAbstractCopyDownload';
import { buildBundlePlainText, sanitizeFilename } from './abstractOutputHelpers';
var RubriqAbstractOutputHeader = function RubriqAbstractOutputHeader(_ref) {
  var _data$generatedWordCo;
  var fileName = _ref.fileName,
    data = _ref.data;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-md-row justify-content-between align-items-md-start gap-3 p-3 border-bottom bg-light"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-1",
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-5 text-truncate"
  }, fileName), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap align-items-center gap-2 text-secondary"
  }, /*#__PURE__*/React.createElement("span", null, t('rubriq.abstract-word-count', (_data$generatedWordCo = data.generatedWordCount) !== null && _data$generatedWordCo !== void 0 ? _data$generatedWordCo : 0)), /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "text-capitalize"
  }, t(data.abstractType)), /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", null, formatForLocale(data.createdAt, t)))), /*#__PURE__*/React.createElement(RubriqAbstractCopyDownload, {
    copyTooltip: "Copy",
    downloadTooltip: "Download",
    filename: sanitizeFilename(fileName),
    getPlainText: function getPlainText() {
      return buildBundlePlainText(data);
    },
    showLabel: true,
    section: "all"
  }));
};
export default RubriqAbstractOutputHeader;